// extracted by mini-css-extract-plugin
export default {"pageTitle":"staff_pageTitle__qOp7D","staffMember":"staff_staffMember__4TrSQ"};